import React, { useState } from "react";
import axios from "axios";
import $ from "jquery";
import { SERVER_URI } from "../utils";

function Contact() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");

    const send_message = () => {
        $("#submitBtn").html("Sending <img src='loader.gif' style='width: 20px;'>");
        $("#submitBtn").attr("disabled", true);
        axios.post(`${SERVER_URI}/my_inbox/`, {
            name, email, subject, message
        }).then((res) => {
            $("#mail_input_div").hide();
            $("#mail_res_div").attr("class", "col-12 text-center d-block");
            $("#mail_response_msg").html(res.data.message);
            setName("");
            setEmail("");
            setSubject("");
            setMessage("");
            $("#submitBtn").html("Send");
            $("#submitBtn").attr("disabled", false);
        })
    }
    const mail_res_goback = () => {
        $("#mail_res_div").attr("class", "d-none");
        $("#mail_input_div").show();
    }
    return (
            <section className="section pt-5" id="contact">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 text-center mb-4">
                        <div className="container-title text-center">
                            <div className="titles">
        <h2 className="title text-capitalize">Get In Touch</h2>
                            </div>
                        </div>
                    </div>

<div className="col-12 text-center d-none" id="mail_res_div">
<h5 className="text-success" id="mail_response_msg">&nbsp;</h5>
<img src="mail_response.gif" alt="response" />
<div className="mt-2">
<button className="btn btn-light btn-sm btn-rounded" onClick={mail_res_goback}>Go Back</button>
</div>
</div>
<div className="col-lg-12" id="mail_input_div">
<div className="custom-form mb-sm-30">
<div className="row">
<div className="col-lg-6">
<div className="row">
<div className="col-lg-12 col-md-6">
<div className="form-group">
<input onChange={(event) => {
    setName(event.target.value);
}} 
value={name} 
type="text" 
className="form-control border rounded" 
placeholder="Name :" 
required />
</div>
</div>
<div className="col-lg-12 col-md-6">
<div className="form-group">
<input onChange={(event) => {
    setEmail(event.target.value);
}} 
value={email} 
type="email" 
className="form-control border rounded" 
placeholder="Email :" 
required />
</div> 
</div>
<div className="col-lg-12">
<div className="form-group">
<input onChange={(event) => {
    setSubject(event.target.value);
}} 
value={subject} 
className="form-control border rounded" 
placeholder="Subject :" 
required />
</div>
</div>
</div>
</div>
<div className="col-lg-6">
<div className="form-group">
<textarea onChange={(event) => {
          setMessage(event.target.value);
        }} 
        value={message} 
        rows="4" 
        className="form-control border rounded" 
        placeholder="Message..." 
        required></textarea>
</div>
</div>
</div>
<div className="row">
<div className="col-sm-12 text-end text-center">
<button onClick={send_message} id="submitBtn" className="btn btn btn-primary rounded">Send</button>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
    );
}

export default Contact;